(function () {
  function initPanelSwap() {
    // Find all panel selectors on the page (there may be one per bundle-product-info section)
    var panelSelectors = document.querySelectorAll('[id^="bundle-panel-selector-"]');

    panelSelectors.forEach(function (panelSelector) {
      var sectionId = panelSelector.id.replace('bundle-panel-selector-', '');

      // Load panel data
      var dataEl = document.getElementById('bundle-panel-data-' + sectionId);
      if (!dataEl) return;

      var panelData;
      try {
        panelData = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      // Build a lookup by handle
      var dataByHandle = {};
      panelData.forEach(function (p) {
        if (p.handle) dataByHandle[p.handle] = p;
      });

      function getSelectedHandle() {
        var checked = panelSelector.querySelector('input[type="radio"]:checked');
        return checked ? checked.dataset.panelHandle : null;
      }

      // Build a list of panel tab section containers (all sections ending in _bp)
      function getPanelSections() {
        return Array.from(document.querySelectorAll('[id*="__"][id$="_bp"], [id*="__"][id$="_bp"] ~ *'))
          .filter(function (el) { return el.id && /__.*_bp$/.test(el.id); })
          .map(function (el) { return el.closest('.shopify-section') || el; });
      }

      function panelQuery(selector) {
        var results = [];
        document.querySelectorAll('[id$="_bp"]').forEach(function (section) {
          section.querySelectorAll(selector).forEach(function (el) { results.push(el); });
        });
        return results;
      }

      function swapPanelContent(handle) {
        var data = dataByHandle[handle];
        if (!data) return;

        // --- Carousel heading ---
        if (data.carousel_heading) {
          panelQuery('[data-panel-swap="carousel-heading"]').forEach(function (el) {
            el.textContent = data.carousel_heading;
          });
        }

        // --- Hero image ---
        if (data.hero_image) {
          panelQuery('[data-panel-swap="hero-image"], [data-panel-swap="hero-image-mobile"]').forEach(function (img) {
            img.src = data.hero_image;
            img.srcset = '';
          });
        }

        // --- Hero heading ---
        if (data.hero_heading) {
          panelQuery('[data-panel-swap="hero-heading"]').forEach(function (el) {
            el.textContent = data.hero_heading;
          });
        }

        // --- Hero subheading ---
        if (data.hero_subheading) {
          panelQuery('[data-panel-swap="hero-subheading"]').forEach(function (el) {
            el.textContent = data.hero_subheading;
          });
        }

        // --- Hero features ---
        if (Array.isArray(data.hero_features) && data.hero_features.length) {
          panelQuery('[data-panel-swap="hero-features"]').forEach(function (featuresEl) {
            var items = featuresEl.querySelectorAll('.ultimate-sauna-dome__feature-item');
            data.hero_features.forEach(function (feature, i) {
              if (items[i]) {
                var textEl = items[i].querySelector('.ultimate-sauna-dome__feature-text');
                if (textEl) textEl.textContent = feature.text;
              }
            });
          });
        }

        // --- Hotspot image ---
        if (data.hotspot_image) {
          panelQuery('[data-panel-swap="hotspot-image"]').forEach(function (img) {
            img.src = data.hotspot_image;
            img.srcset = '';
          });
        }

        // --- Spec values ---
        if (Array.isArray(data.specs) && data.specs.length) {
          var specLookup = {};
          data.specs.forEach(function (s) { specLookup[s.name] = s.value; });

          panelQuery('[data-panel-swap="spec-item"]').forEach(function (item) {
            var specName = item.dataset.specName;
            if (specName && specLookup[specName] !== undefined) {
              var valueEl = item.querySelector('[data-panel-swap="spec-value"]');
              if (valueEl) valueEl.textContent = specLookup[specName];
            }
          });
        }

        // --- Hotspot tooltips ---
        if (Array.isArray(data.hotspot_tooltips) && data.hotspot_tooltips.length) {
          var markers = panelQuery('.control-box-hotspots__marker');
          markers.forEach(function (marker, i) {
            if (!data.hotspot_tooltips[i]) return;
            var titleEl = marker.querySelector('.control-box-hotspots__tooltip-title');
            var descEl = marker.querySelector('.control-box-hotspots__tooltip-description');
            if (titleEl) titleEl.textContent = data.hotspot_tooltips[i].title;
            if (descEl) descEl.textContent = data.hotspot_tooltips[i].description;
          });
        }

        // --- Safety image ---
        if (data.safety_image) {
          panelQuery('[data-panel-swap="safety-image"]').forEach(function (img) {
            img.src = data.safety_image;
            img.srcset = '';
          });
        }

        // --- Safety description ---
        if (data.safety_description) {
          panelQuery('[data-panel-swap="safety-description"]').forEach(function (el) {
            el.innerHTML = data.safety_description;
          });
        }

        // --- Positioning image ---
        if (data.positioning_image) {
          panelQuery('[data-panel-swap="positioning-image"]').forEach(function (img) {
            img.src = data.positioning_image;
            img.srcset = '';
          });
        }
      }

      // Listen for panel change
      panelSelector.addEventListener('change', function () {
        var handle = getSelectedHandle();
        if (handle) swapPanelContent(handle);
      });

      // Run on load with the default selected panel
      var initialHandle = getSelectedHandle();
      if (initialHandle) swapPanelContent(initialHandle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPanelSwap);
  } else {
    initPanelSwap();
  }
})();
